
import { useState, useEffect } from 'react';
import Navbar from '@/components/Navbar';
import ProductGrid from '@/components/ProductGrid';
import Footer from '@/components/Footer';
import { Product } from '@/types';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import { mapDatabaseProductToProduct } from '@/utils/productTransformers';
import { usePwaStatus } from '@/hooks/usePwaStatus';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';

const Index = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [products, setProducts] = useState<Product[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isNewUser, setIsNewUser] = useState(false);
  const { isPwa } = usePwaStatus();

  useEffect(() => {
    fetchProducts();
    checkIfNewUser();
  }, []);

  const fetchProducts = async () => {
    try {
      setIsLoading(true);
      const { data, error } = await supabase
        .from('products')
        .select('*')
        .order('created_at', { ascending: false });

      if (error) throw error;

      if (data) {
        const formattedProducts = data.map(mapDatabaseProductToProduct);
        setProducts(formattedProducts);
      }
    } catch (error) {
      console.error('Error fetching products:', error);
      toast.error("Erreur lors du chargement des produits");
    } finally {
      setIsLoading(false);
    }
  };

  const checkIfNewUser = () => {
    const hasVisitedBefore = localStorage.getItem('hasVisitedBefore');
    if (!hasVisitedBefore) {
      setIsNewUser(true);
      localStorage.setItem('hasVisitedBefore', 'true');
    }
  };

  const handleSearch = (query: string) => {
    setSearchQuery(query);
  };

  const handleInstallPwa = () => {
    // Show PWA installation instructions
    toast.info("Pour installer l'application: Utilisez le menu de votre navigateur et sélectionnez 'Installer l'application' ou 'Ajouter à l'écran d'accueil'");
  };

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar onSearch={handleSearch} />
      
      <main className="container mx-auto px-4 py-8 flex-grow">
        <div className="mb-8">
          <h1 className="text-3xl font-bold mb-2">Mucodec Digital Produit</h1>
          <p className="text-muted-foreground">
            Consultez les licences actives et expirées  
          </p>
        </div>
        
        {!isPwa && (
          <Alert className="mb-4 md:hidden">
            <AlertDescription>
              Pour une meilleure expérience, installez notre application sur votre appareil
              <Button onClick={handleInstallPwa} variant="link" className="p-0 h-auto ml-2">
                Installer
              </Button>
            </AlertDescription>
          </Alert>
        )}
        
        {isLoading ? (
          <div className="flex justify-center items-center h-64">
            <p>Chargement des produits...</p>
          </div>
        ) : (
          <ProductGrid products={products} searchQuery={searchQuery} />
        )}
      </main>
      
      <Footer />
    </div>
  );
};

export default Index;
